<template>
  <div
    class="device-registrator print-no-hidden"
    :class="[
      $store.isDeviceMini ? 'device_mini' : 'device-full',
      isQrDevice && 'fixed',
    ]"
    :style="{
      backgroundColor: $store.registratorBackgroundColor,
      backgroundImage: `url(${$store.mobileBackgroundImage})`,
      fontFamily: `${$store.$store.fontNormalFamily}, ${$store.$store.fontFamilyDefault}, sans-serif`
    }"
  >
    <Modal
      :show="showModal"
      :message.sync="modalMessage"
      @closeModal="showModal = false"
    />

    <ModalCountdown
      :show="showModalCountdown"
      :countdown-seconds="countdownPhoneNumberSeconds"
      @closeModal="closeCountdownModal()"
      @countdowned="closeSession()"
    />

    <PreRecordPage
      v-if="!showPreRecordPhoneModal"
      :show="isShowBookingModal"
      @closeModal="isShowBookingModal = false"
      :qr-device="isQrDevice"
      @pickTicket="applyPrerecordCode($event)"
    />

    <MobilePreRecordPage
      v-if="showPreRecordPhoneModal"
      :show="isShowBookingModal"
      @closeModal="isShowBookingModal = false"
      :qr-device="isQrDevice"
      @pickTicket="applyPrerecordCode($event)"
    />

    <TicketPage
      v-if="pickedTicket"
      class="print-no-hidden"
      :ticket="pickedTicket"
      :device-type="deviceType"
      @pickTicket="onServiceSelected($event)"
      @ticketReady="ticketReady"
    />

    <div v-if="!currentServiceGroup" class="header-wrapper">
      <Header />
    </div>

    <MobilePage
      v-if="
        showAuthoriseByPhone &&
        enteringNumberState === ENTERING_NUMBER_START.NOT_CHOSEN &&
        !shouldShowLanguagePage

      "
      :qr-device="isQrDevice"
      @confirmPhoneNumber="confirmPhoneNumber($event)"
      @cancelEnteringPhoneNumber="cancelEnteringPhoneNumber()"
    />

    <LanguagePage
      v-if="shouldShowLanguagePage"
      @languageSelected="onLanguageSelected"
    />

    <div class="service-list-wrapper">
      <ServiceList
        :style="servicesListStyle"
        :services="$store.deviceStartData.services_tree"
        @changeCurrentGroup="changeCurrentGroup($event)"
        @pickTicket="onServiceSelected($event)"
        @clearTicket="clearTicket()"
        @showPreRecordModal="showModalPreRecord"
      />
    </div>
    <CustomInfoPage
      v-if="additionalInfoRequired && !isQrDevice"
      ref="GroupParamsPage"
      @cancel="closeSession"
      @complete="pickTicket"
    />
    <CustomInfoMobilePage
      v-if="additionalInfoRequired && isQrDevice"
      ref="GroupParamsMobilePage"
      @cancel="closeSession"
      @complete="pickTicket"
    />
  </div>
</template>

<script>
import Header from './components/Header';
import ServiceList from './components/ServiceList';
import Modal from './components/Modal';
import ModalCountdown from './components/ModalCountdown';
import PreRecordPage from './components/PreRecordPage';
import FontService from '../../../services/FontService';
import TicketPage from './components/TicketPage';
import MobilePage from './components/MobilePage';
import MobilePreRecordPage from './components/MobilePreRecordPage';
import CustomInfoPage from './components/GroupParamsPage';
import CustomInfoMobilePage from './components/GroupParamsMobilePage';
import LanguagePage from './components/LanguagePage';
import RegistratorConfig, { DEVICE_TYPES } from './config';
import SOCKET_EVENT from '@/constants/EventType';
import { parseJSON } from '@/helpers/utils';

const ENTERING_NUMBER_START = Object.freeze({
  NOT_CHOSEN: 'not_chosen',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
});

// @pickTicket="pickTicket($event)"

export default {
  name: 'Registrator',
  components: {
    Header,
    ServiceList,
    TicketPage,
    MobilePage,
    Modal,
    ModalCountdown,
    PreRecordPage,
    MobilePreRecordPage,
    CustomInfoPage,
    CustomInfoMobilePage,
    LanguagePage,
  },
  data() {
    return {
      ENTERING_NUMBER_START: ENTERING_NUMBER_START,
      countdownPhoneNumberSeconds:
        RegistratorConfig.DELAY_AFTER_COUNTDOWN_PHONE_NUMBER,
      fontService: new FontService(),
      currentServiceGroup: null,
      pickedTicket: null,
      SOCKET_EVENT: {
        [SOCKET_EVENT.REGISTER_NEW_TICKET]: this.onRegisterNewTicket,
        [SOCKET_EVENT.CALL_TICKET]: this.onCallTicket,
      },
      socketReconnectUnsubscription: null,
      modalMessage: '',
      showModal: false,
      showModalCountdown: false,
      isShowBookingModal: false,
      enteringNumberState: ENTERING_NUMBER_START.NOT_CHOSEN,
      phoneNumber: '',
      showModalCloseSessionTimeout: null,
      deviceType: false,
      additionalInfoRequired: false,
      selectedService: null,
      showLanguagePage: false,
    };
  },
  computed: {
    servicesListStyle() {
      if((this.showAuthoriseByPhone && this.enteringNumberState === ENTERING_NUMBER_START.NOT_CHOSEN)
        || this.isShowBookingModal
        || this.showLanguagePage
        || (this.additionalInfoRequired && this.isQrDevice)
      ) {
        return { opacity: 0 }
      }
      return {}
    },
    shouldShowLanguagePage() {
      return this.$store.deviceStartData.unit_settings.show_lang_selecting_on_main_panel && this.showLanguagePage;
    },
    showAuthoriseByPhone() {
      return this.$store.deviceStartData.unit_settings.show_authorise_by_phone;
    },
    isQrDevice() {
      return this.deviceType === DEVICE_TYPES.QR_CODE;
    },
    searchParams() {
      const search = new URLSearchParams(location.search);
      return {
        noPrint: search.get('no_print') !== null,
      };
    },
    showPreRecordPhoneModal() {
      return Boolean(this.$store.deviceStartData.unit_settings.booking_code_phone);
    },
  },
  mounted() {
    this.socketAuth();
    this.checkTypeDevice();
    this.initEventListeners();
    this.initSocketReconnectEvent();
    this.websocketSubscribe();
    this.setCustomFonts();
    this.showLanguagePage = this.$store.deviceStartData.unit_settings.show_lang_selecting_on_main_panel;
    console.log('store', this.$store)
  },
  destroyed() {
    this.socketReconnectUnsubscription();
  },
  methods: {
    checkTypeDevice() {
      const search = new URLSearchParams(location.search);
      this.deviceType = search.get('type') || DEVICE_TYPES.DEFAULT;
    },
    initEventListeners() {
      this.$root.$on('showModal', ({ message }) => {
        this.showModalWithMessage(message);
      });
    },
    showModalWithMessage(message) {
      this.showModal = true;
      this.modalMessage = message;
    },
    closeCountdownModal() {
      this.showModalCountdown = false;
      this.initShowModalCountdownTimeout();
    },
    initShowModalCountdownTimeout() {
      clearTimeout(this.showModalCloseSessionTimeout);

      this.showModalCloseSessionTimeout = setTimeout(() => {
        this.showModalCountdown = true;
      }, RegistratorConfig.DELAY_BEFORE_COUNTDOWN_PHONE_NUMBER * 1000);
    },
    socketAuth() {
      this.$initService.authorizeDeviceByUID(this.$store.deviceUID);
    },
    initSocketReconnectEvent() {
      this.socketReconnectUnsubscription = this.$eventEmitter.subscribe(
        this.$eventEmitter.eventTypes.SOCKETS_RECONNECT,
        (response) => {
          this.$initService.authorizeDeviceByUID(this.$store.deviceUID);
        },
      );
    },
    websocketSubscribe() {
      this.socketMessageUnsubscription = this.$eventEmitter.subscribe(
        this.$eventEmitter.eventTypes.SOCKETS_MESSAGE,
        (response) => {
          if (response.type !== 'pong') console.log(response);
          if (!response.payload) return;

          parseJSON(response.payload.payload).then((data) => {
            if (this.SOCKET_EVENT[response.payload.event_type]) {
              this.SOCKET_EVENT[response.payload.event_type](data);
            } else {
              console.error(
                `Нет обработчика для event_type = ${response.payload.event_type}`,
                response,
              );
            }
          });
        },
      );
    },
    onRegisterNewTicket({ ticket, counter }) {
      this.updateServiceVisitorsCount(ticket.office_service_id, counter);
    },
    onCallTicket({ ticket, counter }) {
      this.updateServiceVisitorsCount(ticket.office_service_id, counter);
    },
    updateServiceVisitorsCount(serviceId, counter) {
      const { serviceVisitorsCount } = this.$store;

      if (serviceVisitorsCount[serviceId]) {
        this.$store.serviceVisitorsCount[serviceId] = counter;
      } else {
        this.$set(serviceVisitorsCount, serviceId, counter);
      }
    },
    setCustomFonts() {
      const companyFonts = this.$store.deviceStartData.firm_fonts;
      const firmStyle = this.$store.deviceStartData.firm_style;

      const customFonts = this.fontService.getCustomFontsByFontIds(
        companyFonts,
        {
          normalFontId: firmStyle.font_normal,
          semiBoldFontId: firmStyle.font_semi_bold,
          boldFontId: firmStyle.font_bold,
        },
      );

      const customFontsArray = [];

      if (customFonts.fontNormal) {
        customFontsArray.push(customFonts.fontNormal);
      }

      if (customFonts.fontBold) {
        customFontsArray.push(customFonts.fontBold);
      }

      if (customFonts.fontSemiBold) {
        customFontsArray.push(customFonts.fontSemiBold);
      }

      this.fontService.updateFonts(customFontsArray).then(() => {
        if (customFonts.fontNormal) {
          this.$store.fontNormalFamily = customFonts.fontNormal.name;
        }

        if (customFonts.fontBold) {
          this.$store.fontBoldFamily = customFonts.fontBold.name;
        }

        if (customFonts.fontSemiBold) {
          this.$store.fontSemiBoldFamily = customFonts.fontSemiBold.name;
        }
      });
    },
    onServiceSelected(service) {
      this.selectedService = service;

      if (service.group_param_id === null) {
        this.pickTicket(service);
      } else {
        this.collectAdditionalInfo();
      }
    },
    collectAdditionalInfo() {
      this.additionalInfoRequired = true;
      this.$groupParamsService.getParams(this.selectedService.group_param_id);
    },
    pickTicket() {
      console.log('selectedService', this.selectedService.group_param_id);
      if (this.$store.ticketIsProcessing) {
        console.log('Тикет уже обрабатывается');
        return;
      }

      this.$store.ticketIsProcessing = true;

      const pickTicketData = {
        language_tag: this.$store.currentLanguage.tag,
        office_id: this.$store.deviceStartData.device.office_id,
        office_service_id: this.selectedService.id,
      };

      if (this.enteringNumberState === ENTERING_NUMBER_START.CONFIRMED) {
        pickTicketData.phone = this.phoneNumber;
      }

      if (this.selectedService.group_param_id !== null) {
        console.log('here');
        pickTicketData.additional_info = this.$groupParamsService.generateAdditionalInfo();
      }
      console.log('pickTicketData', pickTicketData);

      this.$crudService
        .post(`tickets/`, pickTicketData)
        .then(({ data }) => {
          data.service = this.selectedService.service;
          this.$nextTick(() => (this.pickedTicket = data));
          this.closeSession();
        })
        .catch((error) => {
          this.handlePickTicketError(error);
        })
        .finally(() => {
          this.$store.ticketIsProcessing = false;
        });
    },
    applyPrerecordCode(code) {
      if (this.$store.ticketIsProcessing) {
        return;
      }

      this.$store.ticketIsProcessing = true;

      const pickTicketData = {
        language_tag: this.$store.currentLanguage.tag,
        office_id: this.$store.deviceStartData.device.office_id,
        code: Number(code.replace(/\s/g, '')),
      };

      if (this.enteringNumberState === ENTERING_NUMBER_START.CONFIRMED) {
        pickTicketData.phone = this.phoneNumber;
      }

      this.$crudService
        .post(`tickets/get_by_code`, pickTicketData)
        .then(({ data }) => {
          this.$nextTick(() => (this.pickedTicket = data));
          this.closeSession();
        })
        .catch((error) => {
          this.handlePickTicketError(error);
        })
        .finally(() => {
          this.$store.ticketIsProcessing = false;
        });
    },
    handlePickTicketError(response) {
      const error = response.response.data;

      switch (error.code) {
      case 36:
        this.showModalWithMessage(
          this.$languageService.translateFilter('registrator_service_today_not_provided')
        );
        break;
      case 37:
        this.showModalWithMessage(
          this.$languageService.translateFilter('registrator_service_not_provided')
        );
        break;
      case 38:
        this.showModalWithMessage(
          this.$languageService.translateFilter(error.error)
        );
        break;
      default:
        this.showModalWithMessage(
          this.$languageService.translateFilter('registrator_service_not_available')
        );
      }
    },
    printTicket(data) {
      if (this.searchParams.noPrint) return;
      if (this.$store.isNoPrintTicket) return;
      if (window.PrintAPI) {
        window.PrintAPI.printImage(data);
      } else {
        console.log(data)
        window.print()
      }
    },
    clearTicket() {
      console.log('clearTicket call')
      this.pickedTicket = null;
      this.$root.$forceUpdate();
    },
    ticketReady(data) {
      if (this.isQrDevice) return;
      !this.$store.useIssuingQueue && this.$nextTick(() => this.printTicket(data));

      setTimeout(() => {
        this.$root.$emit('backToMainScreen');
      }, RegistratorConfig.RETURN_AFTER_PICK_TIKET_SECONDS * 1000);
    },
    changeCurrentGroup(group) {
      this.currentServiceGroup = group;

      if (
        this.showAuthoriseByPhone &&
        this.enteringNumberState !== ENTERING_NUMBER_START.NOT_CHOSEN
      ) {
        this.initShowModalCountdownTimeout();
      }
    },
    confirmPhoneNumber(phoneNumber) {
      this.phoneNumber = phoneNumber;
      this.enteringNumberState = ENTERING_NUMBER_START.CONFIRMED;
      this.initShowModalCountdownTimeout();
    },
    cancelEnteringPhoneNumber() {
      this.enteringNumberState = ENTERING_NUMBER_START.CANCELLED;
      this.initShowModalCountdownTimeout();
    },
    closeSession() {
      this.phoneNumber = '';
      this.enteringNumberState = ENTERING_NUMBER_START.NOT_CHOSEN;
      this.$root.$emit('backToMainScreen');
      this.currentServiceGroup = null;
      this.selectedService = null;
      this.additionalInfoRequired = false;
      this.showModalCountdown = false;
      this.showModal = false;
      this.isShowBookingModal = false;
      this.showLanguagePage = this.$store.deviceStartData.unit_settings.show_lang_selecting_on_main_panel;
      clearTimeout(this.showModalCloseSessionTimeout);
    },
    showModalPreRecord(value) {
      this.isShowBookingModal = value;
    },
    onLanguageSelected() {
      this.showLanguagePage = false;
    },
  },
};
</script>

<style lang="scss">
@import '../../../styles/ticket-print';
</style>

<style lang="scss" scoped>
.device-registrator {
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;

  &.fixed {
    height: 100%;
    position: fixed;
  }

  .header-wrapper {
    height: 14.453125vh;
  }

  .service-list-wrapper {
    padding: 0 1.875vw;
    height: 100%;
  }
}
@media screen and (max-height: 1024px) {
  .device-registrator{
    .header-wrapper {
      height: 148px;
    }
  }
}
@media screen and (max-width: 645px) {
  .device-registrator{
    .header-wrapper {
      height: 120px;
    }
    .service-list-wrapper {
      overflow-x: auto;
    }
  }
}
</style>
